var map = {
	"./blue/menu.png": "./src/assets/image/blue/menu.png",
	"./purple/menu.png": "./src/assets/image/purple/menu.png",
	"./red/menu.png": "./src/assets/image/red/menu.png",
	"./yellow/menu.png": "./src/assets/image/yellow/menu.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/image sync recursive ^\\.\\/.*\\/menu\\.png$";